import { render, staticRenderFns } from "./detail-assign.vue?vue&type=template&id=6bcbcd04&scoped=true"
import script from "./detail-assign.vue?vue&type=script&lang=js"
export * from "./detail-assign.vue?vue&type=script&lang=js"
import style0 from "./detail-assign.vue?vue&type=style&index=0&id=6bcbcd04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcbcd04",
  null
  
)

export default component.exports